import { useEffect, useState } from "react";
import axios from "axios";
import { API, IMAGES } from "@/data/site";
import { PackageCard } from "@/components/home/Destinations";
import { Reveal, SectionHead, Accent } from "@/components/Reveal";
import PageHero from "@/components/PageHero";

const FILTERS = ["All", "Heritage", "Adventure", "Beach", "Nature", "Spiritual"];

const Tours = () => {
  const [packages, setPackages] = useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API}/packages`, { params: { type: "india", ...(active !== "All" ? { category: active } : {}) } })
      .then((r) => setPackages(r.data))
      .catch(() => setPackages([]))
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <main data-testid="tours-page">
      <PageHero
        image={IMAGES.indiaService}
        eyebrow="India Tours"
        title={<>Every corner of India, <Accent>your way</Accent></>}
        text="Fixed departures don't live here. Pick a route, tell us your pace and budget — we'll build the rest."
      />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <Reveal>
          <div className="flex flex-wrap gap-3 mb-12" role="tablist" aria-label="Filter packages">
            {FILTERS.map((f) => (
              <button
                key={f}
                role="tab"
                aria-selected={active === f}
                data-testid={`destination-filter-button-${f.toLowerCase()}`}
                onClick={() => setActive(f)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors duration-300 border ${
                  active === f
                    ? "bg-[#F2C230] text-[#0B0F14] border-[#F2C230]"
                    : "border-white/15 text-[#F5F5F0]/70 hover:border-[#3FB6D3]/60 hover:text-[#3FB6D3]"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </Reveal>
        {loading ? (
          <p className="text-[#F5F5F0]/50 text-sm">Loading journeys…</p>
        ) : packages.length === 0 ? (
          <p className="text-[#F5F5F0]/50 text-sm">No packages in this category yet — ask us to build one for you.</p>
        ) : (
          <div className="flex flex-wrap gap-6">
            {packages.map((p) => (
              <PackageCard key={p.id} pkg={p} />
            ))}
          </div>
        )}
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24">
        <Reveal>
          <div className="glass rounded-3xl p-10 sm:p-14 text-center">
            <SectionHead
              align="center"
              eyebrow="Can't Find It?"
              title={<>We build trips that don't exist <Accent>yet</Accent></>}
              text="Tell us the festival, the mountain, the food trail — if it's in India, we can take you there."
            />
            <a href="/contact" data-testid="tours-custom-cta" className="btn-gold mt-8 inline-flex">
              Request a Custom Tour
            </a>
          </div>
        </Reveal>
      </section>
    </main>
  );
};

export default Tours;
